import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'countries';

const CountriesGenerator = createRestAPIModelGenerator(TYPE);
export default CountriesGenerator.createValueListModel();
